import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  openedDialog: EventEmitter<boolean> = new EventEmitter();

  /** Primer mensaje de MensajesError, el texto que el WebAPI escribe para el usuario. */
  static firstMessage(error): string {
    const messages = error && error.error ? error.error.MensajesError : null;
    return messages && messages.length ? messages[0] : '';
  }

  constructor() {}

  openDialog(data) {
    this.openedDialog.emit(data);
  }

  closeDialog() {
    this.openedDialog.emit(null);
  }
}
